import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default function MapPicker({ lat, lng, radius = 200, onPick, testid = "map-picker" }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const circleRef = useRef(null);

  useEffect(() => {
    const map = L.map(ref.current).setView([lat ?? -6.2088, lng ?? 106.8456], lat != null ? 16 : 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
      maxZoom: 19,
    }).addTo(map);
    if (onPick) map.on("click", (e) => onPick(e.latlng.lat, e.latlng.lng));
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 300);
    return () => map.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    if (markerRef.current) markerRef.current.remove();
    if (circleRef.current) circleRef.current.remove();
    if (lat != null && lng != null) {
      markerRef.current = L.circleMarker([lat, lng], { radius: 7, color: "#10b981", fillColor: "#10b981", fillOpacity: 0.9 }).addTo(map);
      circleRef.current = L.circle([lat, lng], { radius: radius || 200, color: "#10b981", weight: 1.5, fillOpacity: 0.12 }).addTo(map);
      map.setView([lat, lng], Math.max(map.getZoom(), 15));
    }
  }, [lat, lng, radius]);

  return <div ref={ref} style={{ height: 300, zIndex: 0 }} className="rounded-lg border border-slate-700" data-testid={testid} />;
}
